import { ResourceAction } from '../../../authentication/authorization-service';
import { ResourceOperations, ResourceTypes } from '../../../authentication/resources';
import { medicalCollaborationTabLabel, medicalCollaborationTabPathName } from '../../../areas/citizen/authority/citizen-authority-area-pathnames';
import { omnibarActionParam, ServiceProviderOmnibarAction } from '../../../areas/citizen/serviceprovider/hooks/use-omnibar-action';
import { OmnibarEntry } from '../omnibar-interfaces';
import { catalogCorrectionsToggle } from '../utils/catalog-corrections';

const tabUrl = `/deeplink/citizen/:contextId/${medicalCollaborationTabPathName}`;
const medicalCollaborationAddon = ['MedicalCollaboration'];

function medicalEntry(id: string, label: string, resourceActions: ResourceAction[], action?: ServiceProviderOmnibarAction): OmnibarEntry {
  return {
    id,
    label,
    keywords: ['læge', 'lægeattest'],
    context: 'citizen',
    group: action ? 'Borgerhandling' : 'Borgerområde',
    url: action ? `${tabUrl}?${omnibarActionParam}=${action}` : tabUrl,
    resourceActions,
    tenantAddonEnabled: medicalCollaborationAddon,
    featureToggleRequired: catalogCorrectionsToggle,
  };
}

const functions: OmnibarEntry[] = [
  medicalEntry('3f9a2d6c-8b1e-4c7a-9e52-d1b7f0a4c836', medicalCollaborationTabLabel, [
    { resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.MedicalCollaboration },
  ]),
  medicalEntry(
    'a8c4e1f7-2d5b-4e9a-b3c6-7f0d2e8a5b14',
    'Opret lægeanmodning',
    [{ resourceOperation: ResourceOperations.Write, resourceType: ResourceTypes.MedicalRequest }],
    ServiceProviderOmnibarAction.CreateMedicalRequest
  ),
  medicalEntry(
    'd2b7f5a9-6c3e-4a1d-8f47-b9e1c4d7a062',
    'Opret lægekorrespondance',
    [{ resourceOperation: ResourceOperations.Write, resourceType: ResourceTypes.MedicalCorrespondence }],
    ServiceProviderOmnibarAction.CreateMedicalCorrespondence
  ),
];

export default functions;
